import { DS_ADOPTION_KEY } from '@manychat/manyui/src/utils/dsAdoption/constants'

import { getIsProductionHost } from '../getIsProductionHost'

let shouldReloadPage = false

const isStorageAdoptionKeySetOnPageLoad = () => {
  if (shouldReloadPage) {
    console.warn('⚠️ Please reload page.')
    return false
  }

  if (window?.localStorage?.getItem(DS_ADOPTION_KEY) !== 'true') {
    window.localStorage.setItem(DS_ADOPTION_KEY, 'true')
    console.warn(
      "⚠️ DS Adoption flag was not set. Setting it now. Please reload page and run 'collectCoverage' again",
    )
    shouldReloadPage = true

    return false
  }

  return true
}

window.collectCoverage = async function (selector = 'body') {
  if (getIsProductionHost()) {
    console.warn('⚠️ collectCoverage is not available in production mode.')
    return
  }

  if (!isStorageAdoptionKeySetOnPageLoad()) {
    return
  }

  const adoption = await import('@manychat/manyui/src/utils/dsAdoption/getVisualDsAdoption')

  if (
    'getVisualDsAdoption' in adoption === false ||
    typeof adoption.getVisualDsAdoption !== 'function'
  ) {
    console.warn('⚠️ getVisualDsAdoption is not available.')
    return
  }

  adoption.getVisualDsAdoption(selector)
}
